import { useRouter } from "next/router";
import { useMemo } from "react";

export default function useIsZH() {
	const { locale } = useRouter();
	const isZh = useMemo(() => ["zh-Hans", "zh-Hant"].includes(locale || ""), [locale]);

	return isZh;
}
